export const enum Tid {
  code = 0,
  name = 1,
  game_title = 2,
  any_key_to_start = 3,
  level_complete = 4,
  pause_prompt = 5,
  score_label = 6,
  game_over = 7,
  zone_0 = 8,
  zone_1 = 9,
  zone_2 = 10,
  zone_3 = 11,
  zone_4 = 12,
  zone_5 = 13,
  tutorial_hold = 14,
  tutorial_release = 15,
}
